import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Skeleton message bubbles shown during the initial messages fetch — alternates sides so the
// thread reads as a conversation, not a stack. The real Message component uses ~70% max-width
// bubbles with sender alignment; this mirrors that rhythm without overcommitting on detail.
function MessagesSkeleton({ count = 4 }) {
  return (
    <div
      className="d-flex flex-column flex-grow-1 overflow-hidden p-3 gap-3"
      aria-hidden="true"
      style={{ color: '#ced4da' }}
    >
      {Array.from({ length: count }).map((_, idx) => {
        const fromCurrent = idx % 2 === 1;
        return (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
            className={classNames('d-flex placeholder-glow', {
              'justify-content-end': fromCurrent,
              'justify-content-start': !fromCurrent,
            })}
          >
            <div className="d-flex flex-column gap-1" style={{ width: '60%', maxWidth: '60%' }}>
              <span className="placeholder rounded-2 col-12" style={{ height: 12 }} />
              <span className="placeholder rounded-2 col-10" style={{ height: 12 }} />
              <span className="placeholder rounded-2 col-6" style={{ height: 12 }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

MessagesSkeleton.propTypes = {
  count: PropTypes.number,
};

export default MessagesSkeleton;
